import type { GroupClient } from '#src/groups/http/group_client.ts';
import type {
  GetGroupForParticipantRequest,
  GetGroupForParticipantResponse,
} from '@packages/contracts/group';
import { Duration } from '@packages/primitives/duration';
import { useQuery } from '@tanstack/react-query';

export function getGroupForParticipantQueryKey({
  groupId,
  participantId,
}: GetGroupForParticipantRequest) {
  return ['group', groupId, 'participant', participantId] as const;
}

export function useGetGroupForParticipant(
  groupClient: GroupClient,
  { groupId, participantId }: GetGroupForParticipantRequest,
) {
  const query = useQuery<GetGroupForParticipantResponse, Error>({
    queryKey: getGroupForParticipantQueryKey({ groupId, participantId }),
    queryFn: () => groupClient.getGroupForParticipant({ groupId, participantId }),
    staleTime: Duration.ofMinutes(2),
    gcTime: Duration.ofMinutes(10),
    retry: false,
  });

  return {
    isPending: query.isPending,
    result: query.data,
    httpError: query.error,
  };
}
